export default __webpack_public_path__ + "static/17_9-a830ab11658f203fe4cd268d1f4d2e9f.png";